import * as React from 'react';
import { Field as RawField } from '@formily/react';
import { useContentName } from '../../hooks/useContentName';
import { useFormInstance, useSelectFirst } from '../../hooks';
import { NonEditable } from './NonEditable';
import { FieldContext, useFieldContext } from './fieldContext';
import { commonMap } from './utils';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const Wrapper = props => {
  useSelectFirst({ ...props.comProps,
    selectFirst: props.selectFirst,
    children: props.children
  });
  let clonedChildren = props.children;

  if ( /*#__PURE__*/React.isValidElement(clonedChildren)) {
    // 需要把status传下去
    clonedChildren = /*#__PURE__*/React.cloneElement(clonedChildren, {
      status: props.status
    });
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: clonedChildren
  });
};

function renderChildren(children, opt, props) {
  const injectProps = { ...commonMap(opt, props)
  };

  if (props.editable === false) {
    return /*#__PURE__*/_jsx(NonEditable, { ...injectProps
    });
  }

  if (children == null) {
    return null;
  }

  if (Array.isArray(children)) {
    return children;
  }

  if ( /*#__PURE__*/React.isValidElement(children)) {
    if (children.type.isField) {
      return children;
    }

    if (!children.props.placeholder && typeof props.label === 'string') {
      injectProps.placeholder = `请输入${props.label}`;
    }

    const childeNode = /*#__PURE__*/React.cloneElement(children, injectProps); // 这里为了实现hoc类似的功能，包裹了一下

    return /*#__PURE__*/_jsx(Wrapper, { ...props,
      comProps: { ...childeNode.props,
        ...injectProps
      },
      children: childeNode
    });
  }

  if (typeof children === 'function') {
    const childContext = children(opt);

    if (childContext === false) {
      return null;
    }

    return childContext;
  }

  return children;
}

export const FieldExtend = props => {
  const form = useFormInstance();
  const {
    preName
  } = useFieldContext();
  const ref = React.useRef(props);
  ref.current = props;
  React.useEffect(() => {
    return () => {
      // 清除一下初始值
      form.setFieldInitialValue(preName, undefined);
      form.clearErrors(preName);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: props.children
  });
};
export const fieldHoc = (FieldUi, opt) => {
  const dataType = opt === null || opt === void 0 ? void 0 : opt.dataType;

  const Field = props => {
    const {
      children,
      name: nameIn,
      requiredOnlyUi,
      rules: rulesIn,
      ...rest
    } = props;
    const {
      name
    } = useContentName(props); // 这里patch一下，否则校验会有些问题

    const rules = rulesIn == null ? {} : rulesIn;
    return /*#__PURE__*/_jsx(RawField, {
      dataType: dataType,
      rules: rules,
      ...rest,
      name: name,
      children: opt => {
        const childrenContext = renderChildren(children, opt, props);
        const error = opt.state.errors[0];
        const required = opt.state.required || requiredOnlyUi;
        const loading = opt.state.loading;
        return /*#__PURE__*/_jsx(FieldContext.Provider, {
          value: {
            preName: name,
            ...opt
          },
          children: /*#__PURE__*/_jsx(FieldExtend, {
            children: props.hideUi ? childrenContext : /*#__PURE__*/_jsx(FieldUi, { ...props,
              required: required,
              loading: loading,
              error: error,
              children: childrenContext
            })
          }, name.toString())
        });
      }
    }, name.toString());
  };

  Field.isField = true;
  return Field;
};
//# sourceMappingURL=es/Other/Field/fieldHoc.js.map